import Vue from 'vue';
import App from '@/App.vue';
import router from '@/router/index.js'
Vue.config.productionTip = false;
Vue.config.ignoredElements = [/ion-\w*/];
import vuetify from '@/plugins/vuetify'
import VueObserveVisibility from 'vue-observe-visibility'
import { VueMaskDirective } from "v-mask";
import VueECharts from 'vue-echarts'
import "echarts";
import { use } from 'echarts/core'
import VueHtmlToPaper from 'vue-html-to-paper';


Vue.directive("mask", VueMaskDirective);
Vue.use(VueObserveVisibility)
const options = {
  name: '_blank',
  specs: [
    'fullscreen=yes',
    'titlebar=yes',
    'scrollbars=yes'
  ],
  styles: [
    'https://maxcdn.bootstrapcdn.com/bootstrap/4.0.0/css/bootstrap.min.css',
    'https://unpkg.com/kidlat-css/css/kidlat.css'
  ]
}

Vue.use(VueHtmlToPaper, options);
/* // or using the defaults with no stylesheet
Vue.use(VueHtmlToPaper); */

import {
  CanvasRenderer
} from 'echarts/renderers'
import {
  BarChart,
  PieChart,
} from 'echarts/charts'
import {
  GridComponent,
  TooltipComponent,
  LegendComponent,
  TitleComponent
} from 'echarts/components'

use([
  CanvasRenderer,
  BarChart,
  PieChart,
  GridComponent,
  TooltipComponent,
  TitleComponent,
  LegendComponent
]);

Vue.component('v-chart', VueECharts)
new Vue({
  VueECharts,
  el: '#app',
  vuetify,
  router,
  render: h => h(App),
})